import { Turmas } from './turmas';

export class TurmaPlanejamentoOficina {
    
	id: number;
	idPlanejamentoOficina: number;
	
	turma: Turmas;
	usuarioAlteracao: number;
    
}
